import { getAgentDomain } from '../config'
import request from '../fetch/index'
import * as Types from './types'
import type { VideoProductImagesItem } from '@/proxy-request/api'

const domain = getAgentDomain()
const localDomain = domain

const fetchConfig = {
  headers: {
    'Content-Type': 'application/json; charset=UTF-8;'
  }
}

/** 获取 market 聊天历史列表 */
export const getAdDataPanelListNewAPI = (arg: { session_id: string; is_current: boolean }) => {
  return request.post<Types.ChatHistoryRespData>(
    localDomain + '/ai_agent/market/chat/history',
    arg,
    fetchConfig
  )
}

export const getSessionIdNewAPI = () => {
  return request.get<{
    session_id: string
    is_new: boolean
  }>(localDomain + '/ai_agent/market/session_id/get', {}, fetchConfig)
}

export const createSessionIdNewAPI = () => {
  return request.post<{
    session_id: string
  }>(localDomain + '/ai_agent/market/session_id/create', {}, fetchConfig)
}

/** 分页查询 AIGC 视频列表 */
export const getVideoListAPI = (params?: Types.VideoListParams) => {
  return request.get<Types.VideoListResponse>(
    localDomain + '/ai_agent/market/video/list',
    params ?? {},
    fetchConfig
  )
}

/** 上传图片（重新上传，需传入 message_id 与 image_url） */
export const reuploadImageAPI = (args: {
  message_id: string
  image_url: string
  origin_image_url: string
}) => {
  return request.post<{
    has_face: boolean //上传的图片中是否包含人脸
  }>(localDomain + '/ai_agent/market/image/reupload', args, fetchConfig)
}

/** 图片重新生成（请求体传 image_url） */
export const regeneImageAPI = (args: Types.RegeneImageRequest) => {
  return request.post<Types.RegeneImageReply>(
    localDomain + '/ai_agent/market/image/regene',
    args,
    fetchConfig
  )
}

/** 停止流式输出（需传入 event_id） */
export const stopStreamAPI = (args: { event_id: string }) => {
  return request.post<Record<string, unknown>>(
    localDomain + '/ai_agent/market/stream/stop',
    args,
    fetchConfig
  )
}

/** 优化创意描述（请求体必传 desc，响应为 SSE 流） */
export const reGeneDescCreativeAPI = (args: {
  desc: string
  images: string[]
  language: string
  duration: number
}) => {
  return request.post<{
    desc: string
  }>(localDomain + '/ai_agent/market/creative/re_gene_desc', args, {
    ...fetchConfig,
    timeout: 5 * 60 * 1000 // 5分钟
  })
}

export const getChatList = (args: { page_size: number }) => {
  return request.get<{
    list: {
      session_id: string
      session_name: string
      start_time: string
    }[]
  }>(domain + '/ai_agent/market/chat/list', args, fetchConfig)
}

export const messageSaveAPI = (args: { message_id: string; value: string }) => {
  return request.post<string>(domain + '/ai_agent/market/message/save', args)
}

export const messageGetAPI = (args: { message_id: string }) => {
  return request.get<{
    ext_data: string
    content: any
  }>(domain + '/ai_agent/market/message/get', args)
}

export const getUserProfileAPI = () => {
  return request.get<{
    has_adv: boolean
    has_product_type: boolean
    is_onboarding: boolean
    is_can_recharge: boolean
    is_first_recharge: boolean
    is_gen2_prepaid_customer: boolean
  }>(domain + '/ai_agent/v1/user/profile', {}, fetchConfig)
}

// 终止视频生成
export const terminateVideoAPI = (args: { video_id: string }) => {
  return request.post<{
    batch_id?: string
    status?: string
    video_id?: string
  }>(`${domain}/ai_agent/market/video/terminate`, args)
}

// 根据 batch_id 查询视频批次详情
export const getVideoBatchAPI = (args: { batch_id: string }) => {
  return request.get<{
    batch_id?: string
    duration?: number
    generate_count?: number
    language?: string
    model?: string
    product_desc?: string
    product_images?: VideoProductImagesItem[]
    ratio?: string
    script_mode?: string
    [property: string]: any
  }>(`${domain}/ai_agent/market/video/batch`, args)
}
